import { IsVisibleOnFilterNotEmptyBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnFilterNotEmptyBase';
export class IsVisibleOnFilterNotEmptyValueConverter extends IsVisibleOnFilterNotEmptyBaseValueConverter {

}